<template>
    <div>
        <!-- Executive Action Bar -->
        <div class="contract-info-header pb-3 mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2"
             v-if="!editing && !insert">
            <div class="d-flex align-items-center gap-2">
                <span class="contract-icon-box">
                    <i class="bi bi-file-earmark-text-fill"></i>
                </span>
                <div>
                    <div class="d-flex align-items-center gap-2">
                        <h6 class="mb-0 fw-bold contract-main-num">{{ data.contractFullNumber }}</h6>
                        <span class="status-badge-pill badge--approved">
                            <i class="bi bi-check-circle-fill me-1"></i> Təsdiqləndi
                        </span>
                    </div>
                    <small class="text-muted" style="font-size: 0.78rem;">Sığorta müqaviləsi və qeydiyyat detalları</small>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex align-items-center flex-wrap gap-2">
                <button type="button" v-if="!send" class="btn action-btn action-btn--success"
                    @click="ToggleEdit(); this.editing = true;">
                    <i class="bi bi-pencil-square me-1"></i>
                    <span>Düzəliş</span>
                </button>

                <button type="button" v-if="$route.path.split('/')[3] == '2'"
                    class="btn action-btn action-btn--success" @click="approveDialog = true">
                    <i class="bi bi-check2-circle me-1"></i>
                    <span>Təsdiq et</span>
                </button>

                <button type="button" v-if="$route.path.split('/')[3] == '2'"
                    class="btn action-btn action-btn--danger" @click="Delete()">
                    <i class="bi bi-x-circle me-1"></i>
                    <span>İmtina</span>
                </button>

                <button type="button" v-if="!send && $route.path.split('/')[3] != '2'"
                    class="btn action-btn action-btn--info" @click="send = true">
                    <i class="bi bi-send-check me-1"></i>
                    <span>Təsdiqə göndər</span>
                </button>

                <button type="button" class="btn action-btn action-btn--muted" @click="GetData()">
                    <i class="bi bi-arrow-clockwise me-1"></i>
                    <span>Yeniləmək</span>
                </button>
            </div>
        </div>

        <!-- Body content -->
        <div v-loading="loading">
            <Data :data="data" v-if="!editing && !insert" :statusData="statusData"></Data>
            <Edit @close-dialog="this.editing = false;" @insert-dialog="ToggleEdit();" :editing="editing"
                v-if="editing || insert" :insert="insert"></Edit>
        </div> 

        <!-- Approve Dialog -->
        <el-dialog :close-on-click-modal="false" v-model="approveDialog" width="420px" title="Müqavilənin təsdiqi"
            modal-class="modal-class" :destroy-on-close="true">
            <div class="p-2">
                <label class="form-label mb-1">Müqavilə başlanma tarixi</label>
                <el-date-picker format="DD.MM.YYYY" v-model="startDate" class="w-100" type="date"
                    placeholder="Tarixi seçin" />
            </div>
            <template #footer>
                <div class="d-flex justify-content-end gap-2 pt-2 border-top">
                    <button type="button" class="btn action-btn action-btn--muted" @click="approveDialog = false">
                        İmtina
                    </button>
                    <button type="button" class="btn action-btn action-btn--success" @click="Approve()">
                        <i class="bi bi-check-lg me-1"></i>
                        <span>Daxil et</span>
                    </button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import Edit from "./Components/Edit.vue";
import Data from "./Components/Data.vue";

export default {
    name: "ContractInfoMain",
    components: {
        Data,
        Edit
    },
    data() {
        return {
            send: false,
            startDate: null,
            approveDialog: false,
            data: {
                policyId: 101,
                contractDateStr: "01.01.2025",
                contractFullNumber: "KM-2025-0001",
                startDate: "01.01.2025",
                endDate: "31.12.2025",
                descr: "İlkin müqavilə",
                addCond: "Əlavə endirim 5%",
                insured: {
                    name: "ABC Sığorta MMC",
                    address: "Bakı, Nərimanov, Ağa Nemətulla 23",
                    phone: "+994 50 123 45 67",
                    voen: "1234567891",
                    clientSector: "İT və xidmət"
                },
                resp: {
                    name: "Rauf Məmmədov",
                    address: "Bakı şəhəri",
                    phone: "+994 55 765 43 21"
                }
            },
            statusData: [
                {
                    statusId: 0,
                    status: "Yeni",
                    user: "Rufiz Məmmədov",
                    time: "16.08.2025 14:22"
                },
                {
                    statusId: 4,
                    status: "Göndərildi təsdiqə",
                    user: "Aygün Quliyeva",
                    time: "16.08.2025 14:45"
                },
                {
                    statusId: 2,
                    status: "Təsdiqləndi",
                    user: "Admin",
                    time: "16.08.2025 15:05"
                }
            ],
            loading: false,
            editing: false,
            insert: false
        };
    },
    methods: {
        ToggleEdit() {
            this.$emit('insert');
        },
        GetData() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 300);
        },
        Approve() {
            window.location.href = window.location.origin + '/documents/policy/' + 3;
        },
        async Delete() {
            // None
        }
    },
    mounted() {
        if (this.$route.path.split("/")[3] === "new") {
            this.insert = true;
        }
        this.GetData();
    }
};
</script>

<style scoped lang="scss">
.contract-info-header {
    border-bottom: 1px solid var(--app-border, #e2e8f0);
}

.contract-icon-box {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: rgba(11, 79, 156, 0.1);
    color: var(--bs-info, #0b4f9c);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
}

.contract-main-num {
    font-size: 1rem;
    color: var(--app-heading, #1e293b);
}

.status-badge-pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 9999px;
    font-size: 0.74rem;
    font-weight: 700;

    &.badge--approved {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.35);
    }
}

[data-theme="dark"] {
    .contract-info-header {
        border-color: #283544;
    }

    .contract-icon-box {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
    }

    .contract-main-num {
        color: #f1f5f9;
    }

    .status-badge-pill.badge--approved {
        background: rgba(16, 185, 129, 0.18);
        color: #34d399;
        border-color: rgba(52, 211, 153, 0.35);
    }
}
</style>